import { useEffect, useState } from "react";

// Shared collapsible-sidebar state, persisted for the active session so the
// user's preference survives navigation (but resets on a new session).
export function useSidebarCollapsed(key = "cre-sidebar-collapsed") {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(key) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, collapsed ? "1" : "0");
    } catch {
      /* ignore storage failures (private mode etc.) */
    }
  }, [collapsed, key]);

  return { collapsed, setCollapsed, toggle: () => setCollapsed((c) => !c) };
}
